import { fetchUserData } from "./authService";

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

const getUserData = async () => {
  const token = localStorage.getItem("access_token");

  if (!token) {
    console.error("No access token found");
    return null;
  }
  console.log("token : ", token);

  try {
    const response = await fetchUserData();

    const userData = response?.data;
    return userData;
  } catch (error) {
    console.log("Error fetching user data:", error);
    return null;
  }
};

export default getUserData;
